export const Series = "VMKB2_064"; // Material name
export const Size = "VBGR_064"; // Size code
export const GuidewayDesign = "VSAF_064"; // Guideway design
export const Version = "VVER_064"; // Guideway design

export const Coating = "VBSCH_064"; // Coating
export const Accuracy = "VGEN_064"; // Accuracy class

export const MountingHoleType = "VSBF_064"; // Rail mounting hole type
export const ClosingPlugs = "VH_SKA_064"; // Closing plugs
export const CounterboreChamfered = "VSSBG_064"; // Counterbore Chamfered

export const LocatingFace = "VANS_064";

export const GuidewayLength = "VKWL_1D_064";

export const AL = "VAAL_064";
export const AR = "VAAR_064";
export const AlarMinRecommended = "VAL_IB_064";
export const AlarMaxRecommended = "VAL_AB_064";
export const AlarHardMax = "VALR_A_064";

export const PartSizing = "VVST_064"; // Possible values: No parts, automatic split, manual split
export const PartAmount = "VTLA_064";

export const PartOneLength = "VTL01_064";
export const PartTwoLength = "VTL02_064";
export const PartThreeLength = "VTL03_064";
export const PartFourLength = "VTL04_064";
export const PartFiveLength = "VTL05_064";

export const DesignType_Series = "VB_MKB_064";
export const DesignType_SizeCode = "VB_BGR_064";
export const DesignType_Version = "VB_VER_090";
export const DesignType_GuidewayDesign = "VB_SAF_064";
